import styled from "styled-components";

export const StyledLink = styled.p`
     border-radius:50%;
     width:100%;
     display: flex;
     align-items: center;
     justify-content: flex-start;
     text-decoration: none;
     margin: 16px 0px;
`;